import React, { useState, useRef } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { MdOutlinePeopleAlt, MdLockOutline } from "react-icons/md";
import { GoGlobe } from "react-icons/go";
import { useDispatch } from "react-redux";
import { POST_DELETED } from "../../redux/actions/journal";
// import NoImage from "../../common/noimage/no-image.jpg"
import ButtonHashtag from "../../components/Button/ButtonHashtag";
import ModalShare from "./ModalShare";
import ShareTo from "../Community/ShareTo";
import {
  htmlToText,
  trimString,
  convertDate,
  removeIframe,
  tokenAuthorize,
  addAttribute,
} from "../../components/Helpers/Common";
import axios from "axios";
import Swal from "sweetalert2";
import Tooltip from "@mui/material/Tooltip";
import { serverUrl } from "../../components/Helpers/Config";
import { staticFiles } from "../../components/Helpers/Static";
import {
  ButtonCommonDelete,
  ButtonCommonTopGrey,
  ButtonCommonTopNew,
  Card,
  MenuItemCard,
  MenuItemDiv,
} from "../Theme";
import {
  fillList,
  hideShareto,
  showShareto,
} from "../../redux/actions/sharePost";
import { getPosts } from "../../redux/actions/journal";
import { getShowcaseDetails } from "../../redux/actions/showcase";
import FeedbackHistoryButton from "../../components/Button/FeedbackHistoryButton";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import Menu from "@mui/material/Menu";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import ShareIcon from "@mui/icons-material/Share";
import ShareRoundedIcon from "@mui/icons-material/ShareRounded";
import { FaTrashAlt } from "react-icons/fa";
import { BsStars } from "react-icons/bs";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import { FaRegCommentDots } from "react-icons/fa";

const NO_IMAGE = staticFiles.noImage;

const JournalGridCard = ({
  item,
  selection,
  index,
  set,
  getShared,
  historyEnabled,
  ...props
}) => {
  const { path } = useRouteMatch();
  const history = useHistory();
  const dispatch = useDispatch();
  const [showModalShare, setShowModalShare] = useState(false);

  const [anchorElJournal, setAnchorEl] = useState(null);
  const open = Boolean(anchorElJournal);
  const handleDownloadClick = (e) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };
  const handleDownloadClose = (e, reflectionId, file) => {
    e.stopPropagation();
    setAnchorEl(null);
    if (reflectionId) {
      handleDownload(e, reflectionId, file);
    }
  };
  const Tags = ({ text, ...props }) => {
    let icon =
      props.type === "showcase" ? (
        <GoGlobe className="mr-2" />
      ) : props.type === "community" ? (
        <MdOutlinePeopleAlt className="mr-2" />
      ) : props.type === "private" ? (
        <MdLockOutline className="mr-2" />
      ) : (
        ""
      );

    let texts =
      props.type === "showcase" || props.type === "community"
        ? `${text}`
        : `shared in ${text}`;

    let style =
      text === "private"
        ? "bg-gray-200 text-gray-500"
        : "bg-blue-200 text-blue-500";
    style += " w-max p-2 px-4 rounded-lg flex items-center font-semibold";
    return (
      <div className={style}>
        {icon} {texts}
      </div>
    );
  };

  const handleSelect = (e) => {
    e.stopPropagation();
    set(e);
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    history.push(`/journal/edit/${item.reflection_id}`, {
      post: item,
      journal: true,
    });
  };

  // const handleShare = (e) => {
  //     e.stopPropagation();
  //     setShowModalShare(true)
  // }
  const handleShareTo = (e, item) => {
    // setDropdown(false)

    e.stopPropagation();
    dispatch(showShareto());
    dispatch(fillList([item]));
  };

  const handleCloseModal = (e) => {
    e.stopPropagation();
    setShowModalShare(false);
  };

  const handleDelete = (e) => {
    e.stopPropagation();

    Swal.fire({
      heightAuto: false,
      title: "Confirmation",
      text: "Are you sure to delete this post?",
      icon: "warning",
      showCancelButton: false,
      showDenyButton: true,
      confirmButtonText: "Confirm",
      denyButtonText: "Cancel",
      confirmButtonColor: "#3085d6",
      denyButtonColor: "#c1c1c1",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`${serverUrl.Post}/${item.reflection_id}`)
          .then(() => {
            dispatch({
              type: POST_DELETED,
              payload: { postId: item.reflection_id },
            });
            dispatch(getShowcaseDetails());
            dispatch(getPosts());
            getShared();
            Swal.fire({
              heightAuto: false,
              title: "Success",
              text: "Post has been deleted",
              icon: "success",
            });
          })
          .catch((err) => {
            tokenAuthorize(err?.response?.status);
            // Swal.close();
          });
      }
    });
  };
  const handleDownload = async (e, id, file) => {
    e.stopPropagation();
    try {
      let url =
        file === "word"
          ? serverUrl.ReflectionExportWord
          : serverUrl.ReflectionExport;
      const response = await axios.get(`${url + "/" + id}`, {
        headers: { "Content-Type": "multipart/form-data" },
        responseType: "blob",
      });
      if (response.status === 200) {
        // Extract Content-Disposition header
        const contentDisposition =
          (response.headers && response.headers["content-disposition"]) ||
          response.headers["Content-Disposition"];
        // Default filename
        let filename = file === "word" ? "reflection.docx" : "reflection.pdf";
        // Extract filename from Content-Disposition
        if (contentDisposition) {
          const match = contentDisposition.match(
            /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
          );
          if (match && match[1]) {
            filename = match[1].replace(/['"]/g, ""); // Remove quotes if present
          }
        }
        // Create Blob and trigger download
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
      } else {
        Swal.fire({
          title: "Info",
          text: "No data found",
          icon: "info",
        });
      }
    } catch (err) {
      console.error("Error:", err);
      Swal.fire({
        title: "Info",
        text: "No data found",
        icon: "info",
      });
    }
  };

  const navigateHistoryPage = (e, reflectionID) => {
    e.stopPropagation();
    history.push(`/journal/edit/${reflectionID}/pastreviewhistory`);
  };

  const formatModernDate = (isoDate) => {
    const date = new Date(isoDate);
    return date.toLocaleDateString("en-GB", {
      year: "numeric",
      month: "short", // Jan, Feb, Mar, etc.
      day: "numeric", // 1, 2, 3...
    });
  };

  return (
    <Card
      className="flex shadow-sm  w-full relative cardBackgroundColor border20px p-4 pt-1 pb-0 cursor-pointer hover:opacity-90 h-70"
      onClick={props.onClick}
    >
      {props.selectEnabled && (
        <input
          type="checkbox"
          className="absolute top-4 cursor-pointer right-6 w-4 h-4 checkBoxCustom"
          name={item.reflection_id}
          checked={selection}
          onChange={handleSelect}
          onClick={(e) => {
            e.stopPropagation();
          }}
        />
      )}
      <div class={`${"grid grid-rows-1 w-full"}`}>
        <div className="flex flex-col px-2 pt-2 py-4 min-height-grid">
          <div className="col-start-1 flex items-center ">
            <div className="font-semibold break-words multiline-ellipsis">
              {item.reflection_title}
            </div>
          </div>
          <div className="flex items-center justify-between ">
            <span className="font-medium text-sm lightColor">
              {formatModernDate(item.reflection_created_on)}
            </span>
            <span className="font-medium text-sm lightColor gap-2 flex">
              <span className="flex items-center">
                <ThumbUpAltIcon fontSize="small" /> {item.likecount}
              </span>
              <span className="flex items-center gap-0.5">
                <FaRegCommentDots />
                {item.commentcount}
              </span>
              {/* <span>Likes - {item.likecount}</span>
              <span>Comments - {item.commentcount}</span> */}
            </span>
          </div>
          {/* <div className="md:col-start-2 lg:col-start-2 xl:col-start-2 sm:col-start-1 col-start-1 flex items-center justify-end">
                        <div className="flex md:float-right xl:float-right lg:float-right">
                            <div className='font-medium text-sm lightColor'>
                                {formatModernDate(item.reflection_created_on)}
                            </div>
                        </div>
                    </div> */}
        </div>
        <div class={`grid grid-cols-1 px-1`}>
          <img
            src={item.reflection_image ? item.reflection_image : NO_IMAGE}
            className="w-full background-image-grid  border20px"
            alt=""
            onError={(e) => {
              e.target.src = NO_IMAGE;
            }}
          />
          {/* <div
            className={
              item.reflection_image
                ? "background-image-grid border20px"
                : "background-image-grid border20px bg-center"
            }
            style={{
              backgroundImage: item.reflection_image
                ? "url(" + item.reflection_image?.replaceAll(" ", "%20") + ")"
                : "url(" + NO_IMAGE + ")",
            }}
          >
            <div className="inline-block"></div>
          </div> */}
        </div>
        <div
          className={`px-2 pb-2 mt-4 flex flex-wrap ${
            item.feedbackcount !== "0" && historyEnabled
              ? "justify-between"
              : "justify-between"
          }`}
        >
          <div className="flex items-center gap-3">
            {item.feedbackcount !== "0" && historyEnabled ? (
              <Tooltip title={"Feedback History"} placement="top" arrow>
                <ButtonCommonTopNew
                  className="text-xs lg:text-sm rounded-lg w-10 h-9 mb-2 flex justify-center items-center font-regular "
                  onClick={(e) => navigateHistoryPage(e, item.reflection_id)}
                >
                  <BsStars
                    style={{ fontSize: "16px" }}
                    className=" blueColor"
                  />
                </ButtonCommonTopNew>
              </Tooltip>
            ) : (
              // <FeedbackHistoryButton text="Feedback History" color="blue" onClick={(e) => navigateHistoryPage(e, item.reflection_id)} />
              <></>
            )}
            <Tooltip title={"Download"} placement="top" arrow>
              <ButtonCommonTopNew
                className={`text-xs lg:text-sm rounded-lg w-10 h-9 mb-2 flex justify-center items-center font-regular`}
                id="journal-download-button"
                aria-controls={
                  open ? "journal-download-menu" + index : undefined
                }
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={(e) => handleDownloadClick(e)}
              >
                <FileDownloadOutlinedIcon
                  style={{ fontSize: "20px" }}
                  className=" blueColor"
                />
                {/* <p className={`text-blue-dark font-semibold text-xs`}>Download</p> */}
              </ButtonCommonTopNew>
            </Tooltip>
            <Menu
              id={"journal-download-menu" + index}
              anchorEl={anchorElJournal}
              open={open}
              onClose={(e) => handleDownloadClose(e)}
              MenuListProps={{
                "aria-labelledby": "journal-download-button",
              }}
              disableScrollLock={true}
            >
              <MenuItemDiv
                className="w-20 text-sm flex pt-1 items-center hover:opacity-70 cursor-pointer ml-3"
                onClick={(e) =>
                  handleDownloadClose(e, item.reflection_id, "pdf")
                }
              >
                PDF
              </MenuItemDiv>
              <MenuItemDiv
                className="w-20 text-sm flex pt-1 items-center hover:opacity-70 cursor-pointer ml-3"
                onClick={(e) =>
                  handleDownloadClose(e, item.reflection_id, "word")
                }
              >
                Word
              </MenuItemDiv>
            </Menu>
          </div>
          <div className="flex items-center gap-3">
            <Tooltip title={"Edit"} placement="top" arrow>
              <ButtonCommonTopNew
                className="text-xs lg:text-sm rounded-lg w-10 h-9 mb-2 flex justify-center items-center font-regular "
                onClick={handleEdit}
              >
                <BorderColorOutlinedIcon
                  style={{ fontSize: "16px" }}
                  className=" blueColor"
                />
              </ButtonCommonTopNew>
            </Tooltip>
            <Tooltip title={"Share"} placement="top" arrow>
              <ButtonCommonTopNew
                className="text-xs lg:text-sm mb-2  rounded-lg w-10 h-9 flex justify-center items-center  hover:bg-gray-200"
                onClick={(e) => handleShareTo(e, item)}
              >
                <ShareIcon style={{ fontSize: "18px" }} className="blueColor" />
              </ButtonCommonTopNew>
            </Tooltip>
            <Tooltip title={"Delete"} placement="top" arrow>
              <ButtonCommonDelete
                className=" mb-2 font-regular  text-xs lg:text-sm  rounded-lg w-10 h-9 flex justify-center items-center hover:bg-gray-200"
                onClick={handleDelete}
              >
                <FaTrashAlt
                  style={{ fontSize: "16px" }}
                  className="deleteColor"
                />
              </ButtonCommonDelete>
            </Tooltip>
          </div>
        </div>
        {/* <div className="grid md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 sm:grid-cols-1 grid-cols-1 p-2 pt-4 gap-2">
                    <div className="md:col-start-1 lg:col-start-1 xl:col-start-1 sm:col-start-1 col-start-1">
                        <ButtonCommonTopNew
                            className='text-xs lg:text-sm rounded-lg py-2 mb-2 flex justify-center items-center font-regular '
                            onClick={handleEdit}
                        >
                            <BorderColorOutlinedIcon style={{ fontSize: '14px' }} className='mr-1 blueColor' />Edit
                        </ButtonCommonTopNew>
                    </div>
                    <div className="md:col-start-2 lg:col-start-2 xl:col-start-2 sm:col-start-1 col-start-1">
                        {
                            // false &&
                            <ButtonCommonTopNew
                                className='text-xs lg:text-sm mb-2  rounded-lg py-2 w-full flex justify-center items-center  hover:bg-gray-200'
                                onClick={(e) => handleShareTo(e, item)}
                            >
                                <ShareIcon style={{ fontSize: '15px' }} className='mr-1 blueColor' />Share
                            </ButtonCommonTopNew>
                        }
                    </div>
                    <div className="md:col-start-3 lg:col-start-3 mb-2 xl:col-start-3 sm:col-start-1 col-start-1">
                        <ButtonCommonDelete
                            className=' mb-2 font-regular  text-xs lg:text-sm  rounded-lg py-2 w-full flex justify-center items-center hover:bg-gray-200'
                            onClick={handleDelete}
                        >
                            <FaTrashAlt style={{ fontSize: '14px' }} className='mr-1 deleteColor' />Delete
                        </ButtonCommonDelete>
                    </div>
                </div> */}
      </div>
    </Card>
  );
};

export default JournalGridCard;
